import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { BulkActionActionContext } from "@beeldit/core/context/BulkActionContext";
import { GenerateInvoiceActionContext } from "./GenerateInvoiceActionContext";

function useGenerateInvoice(modelConfig: any) {
  const { setShowModal, setLoading, generatePdf, sendToCustomer, separatedInvoices } = useContext(GenerateInvoiceActionContext);
  const { elementIds } = useContext(BulkActionActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    setLoading(true);
    store("invoices/generate", { 
      element_ids: elementIds,
      generate_pdf: generatePdf,
      send_to_customer: sendToCustomer,
      separated_invoices: separatedInvoices
    })
      .then(() => {
        setShowModal(false);
        onSuccess();
      })
      .catch((error: any) => {
        errorHandler(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
}

export default useGenerateInvoice;
